export default "__VITE_ASSET__CJPyhU$D__"